export default [{
    id: '5dd3b237-5d06-4b9b-b031-0f1585f6b15e',
    slug: 'aires-mateus-materia-em-avesso',
    title: 'Aires Mateus: Matéria em Avesso',
    type: 'film',
    images: {
      thumbnail: require('../../images/projects/aires_thumb.jpg'),
      poster: require('../../images/projects/aires_poster.jpg')
    },
    info: {
      director: 'Henrique Pina',
      cinematography: 'António Lima',
      music: 'Noiserv',
      genre: 'Documentary',
      runtime: '65 minutes',
    },
    links: {
      vimeo: 'https://player.vimeo.com/video/235599516'
    }
  },
  {
    id: '2c51bb3e-d25d-472b-a632-72214b244b94',
    slug: 'traca-mar-deserto',
    title: 'Traça - Mar Deserto',
    type: 'film',
    images: {
      thumbnail: require('../../images/projects/traca_thumb.png'),
      poster: require('../../images/projects/traca_poster.jpeg')
    },
    info: {
      director: 'Henrique Pina',
      cinematography: 'Lee Fuzeta',
      music: 'Mar Desert',
      runtime: '65 minutes'
    },
    cast: ['Filipe Duarte'],
    related_work: [{
      name: 'Andycode - The Glare',
      url: "https://vimeo.com/203446278"
    }],
    links: {
      vimeo: 'https://player.vimeo.com/video/205581479'
    }
  },
  {
    id: 'c97dc35d-4517-4a93-bdc2-a070109f2bf5',
    slug: 'o-mundo-cai-aos-bocados',
    title: 'O Mundo Cai aos Bocados',
    subtitle: '(e ainda assim as pessoas apaixonam-se)',
    type: 'film',
    images: {
      thumbnail: require('../../images/projects/mundo_thumb.png'),
      poster: require('../../images/projects/mundo_poster.jpg')
    },
    info: {
      director: 'Henrique Pina',
      cinematography: 'Paulo Segadães, António Lima',
      music: 'André G. Mendes',
      genre: 'Short Film ',
      runtime: '20 minutes',
      script: 'Francisco Baptista'
    },
    cast: [
      'Albano Jerónimo',
      'Joana Solnado',
      "António Victorino d'Almeida",
      'José Wallenstein',
      'David Almeida',
      'Miguel Borges'
    ],
    links: {
      vimeo: 'https://player.vimeo.com/video/130768538'
    }
  }, {
    id: '4a75a574-0342-4c8d-967b-29c0b7bbeda4',
    slug: 'grants-stand-together',
    title: "Grant's Stand Together",
    type: 'advertisement',
    images: {
      thumbnail: require('../../images/projects/grants_thumb.png'),
      poster: require('../../images/projects/grants_poster.jpg')
    },
    info: {
      director: 'Henrique Pina',
      cinematography: 'Lee Fuzeta',
      agency: 'H2N',
      client: "Grant's",
    },
    links: {
      vimeo: 'https://player.vimeo.com/video/222182728'
    }
  }, {
    id: 'd9d7dcf7-873b-4711-86c6-791c8fb3fe5c',
    slug: 'my-story-hotels',
    title: "My Story Hotels",
    type: 'advertisement',
    images: {
      thumbnail: require('../../images/projects/story_thumb.png'),
      poster: require('../../images/projects/story_poster.jpeg')
    },
    info: {
      director: 'Henrique Pina',
      cinematography: 'Leandro Silva',
      client: "My Story Hotels",
    },
    links: {
      vimeo: 'https://player.vimeo.com/video/204515471'
    }
  }, {
    id: '9989804e-bc30-4c7b-9bf6-632e4acc2b63',
    slug: 'boom-app',
    title: "BoomApp",
    type: 'advertisement',
    images: {
      thumbnail: require('../../images/projects/boomapp_thumb.png'),
      poster: require('../../images/projects/boomapp_poster.jpg')
    },
    info: {
      director: 'Henrique Pina',
      cinematography: 'António Lima',
      copywritter: 'Gonçalo Costa',
      client: "BoomApp",
    },
    links: {
      vimeo: 'https://player.vimeo.com/video/203449465'
    }
  }, {
    id: '9989804e-bc30-4c7b-9bf6-632e4acc2b654',
    slug: 'fox-life-epoca-alta',
    title: "Fox Life - Época Alta",
    type: 'advertisement',
    images: {
      thumbnail: require('../../images/projects/fox2_thumb.png'),
      poster: require('../../images/projects/fox1_fox2-poster.jpeg')
    },
    info: {
      director: 'Henrique Pina',
      cinematography: 'António Lima',
      client: "FOX",
    },
    related_work: [{
      name: "Péu",
      url: "https://vimeo.com/203451322"
    }],
    links: {
      vimeo: 'https://player.vimeo.com/video/203451178'
    }
  }, {
    id: '9989804e-bc30-4c7b-9bf6-632e4acc2b609',
    slug: 'fitness-hut',
    title: "Fitness Hut",
    type: 'advertisement',
    images: {
      thumbnail: require('../../images/projects/hut-thumb.png'),
      poster: require('../../images/projects/hut-poster.jpeg')
    },
    info: {
      director: 'Henrique Pina',
      cinematography: 'António Lima, Lee Fuzeta',
      client: "Fitness Hut"
    },
    links: {
      vimeo: 'https://player.vimeo.com/video/204517185'
    }
  }, {
    id: '9989804e-bc30-4c7b-9bf6-632e4acc2b612',
    slug: 'ccb-dias-de-musica',
    title: "CCB - dias de musica",
    type: 'advertisement',
    images: {
      thumbnail: require('../../images/projects/ccb_thumb.png'),
      poster: require('../../images/projects/ccb_poster.jpeg')
    },
    info: {
      director: 'Henrique Pina',
      cinematography: 'António Lima',
      client: "Centro Cultural de Belém",
    },
    related_work: [{
      name: "COPPIA",
      url: "https://vimeo.com/203449226"
    }, {
      name: "Multiplex",
      url: "https://vimeo.com/203448693"
    }, {
      name: "CCB 2014",
      url: "https://vimeo.com/203448210"
    }],
    links: {
      vimeo: 'https://player.vimeo.com/video/203449453'
    }
  }

]



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectsData.js